import type {KpPdfViewerControlPanelComponentController} from './kp-pdf-viewer-control-panel.component';
import PdfViewerProxy from './pdf-viewer-proxy';
import PdfViewerControlPanelProxy from './pdf-viewer-control-panel-proxy';
import type {KpPdfViewerComponentController} from '../kp-pdf-viewer/kp-pdf-viewer.component';
import type PdfProxiedCommands from './pdf-proxied-commands';

export default class KpPdfViewerControlPanelService {
    public static serviceName = 'pdfViewerControlPanelService';

    private pdfViewerProxies: { [id: string]: PdfViewerProxy } = {};
    private pdfControlPanelProxies: { [id: string]: PdfViewerControlPanelProxy } = {};

    public registerPdfViewerController(id: string, controller: KpPdfViewerComponentController): PdfProxiedCommands {
        if (!this.pdfViewerProxies[id]) {
            this.pdfViewerProxies[id] = new PdfViewerProxy(controller);
        } else {
            if (!this.pdfViewerProxies[id].hasController()) {
                this.pdfViewerProxies[id].setController(controller);
            } else {
                throw new Error('KpPdfViewerControlPanelService: registerPdfViewerController: try to set existing controller');
            }
        }

        if (!this.pdfControlPanelProxies[id]) {
            return this.pdfControlPanelProxies[id] = new PdfViewerControlPanelProxy();
        }

        return this.pdfControlPanelProxies[id];
    }

    public registerPdfControlPanelController(id: string, controller: KpPdfViewerControlPanelComponentController): PdfProxiedCommands {
        if (!this.pdfControlPanelProxies[id]) {
            this.pdfControlPanelProxies[id] = new PdfViewerControlPanelProxy(controller);
        } else {
            if (!this.pdfControlPanelProxies[id].hasController()) {
                this.pdfControlPanelProxies[id].setController(controller);
            } else {
                throw new Error('KpPdfViewerControlPanelService: registerPdfControlPanelController: try to set existing controller');
            }
        }

        if (!this.pdfViewerProxies[id]) {
            return this.pdfViewerProxies[id] = new PdfViewerProxy();
        }

        return this.pdfViewerProxies[id];
    }

    public unregisterPdfViewerController(id: string) {
        this.pdfViewerProxies[id].removeController();
    }

    public unregisterPdfControlPanelController(id: string) {
        this.pdfControlPanelProxies[id].removeController();
    }
}
